<template>
  <div class="page-home">
    <div class="divider"></div>
    <section class="section-home">
      <div class="home-banner-slider-wrapper">
        <home-banner-slider></home-banner-slider>
      </div>
    </section>
    <div class="divider"></div>
    <section class="section-home">
      <block-content class="block-content-home block-content-full-width block-content-sec">
        <template v-slot:media>
          <img :src="secImgSrc" alt="banner_img_sec">
        </template>
        <template v-slot:text-content>
          <div class="text-content-home text-content-sec">
            <div class="text-title text-title--sec">{{ $t('home.blockContent_2.title') }}</div>
            <div class="text-content-desc text-content-desc--sec">
              {{ $t('home.blockContent_2.desc') }}
            </div>
            <a
              class="btn btn-learn-more btn-learn-more--sec"
              href="/product/tableware">{{ $t('common.learnMore') }}</a>
          </div>
        </template>
      </block-content>
    </section>
    <div class="divider"></div>
    <section class="section-home">
      <block-content class="block-content-home block-content-full-width block-content-bib">
        <template v-slot:media>
          <img :src="bibImgSrc" alt="banner_img_bib">
        </template>
        <template v-slot:text-content>
          <div class="text-content-home text-content-bib">
            <div class="text-title text-title--bib">{{ $t('home.blockContent_bib.title') }}</div>
            <div class="text-content-desc text-content-desc--bib">
              {{ $t('home.blockContent_bib.desc') }}
            </div>
            <a
              class="btn btn-learn-more btn-learn-more--bib"
              href="/product/sillicone-feeding-bib/">{{ $t('common.learnMore') }}</a>
          </div>
        </template>
      </block-content>
    </section>
    <div class="divider"></div>
    <section class="section-home section-col-2">
      <block-content
        class="block-content-home"
        :class="{'block-content-half': !isMobile, 'block-content-full-width': isMobile}">
        <template v-slot:media>
          <img :src="halfFirstImgSrc" alt="banner_img">
        </template>
        <template v-slot:text-content>
          <div class="text-content-home text-content-half-first">
            <div class="text-title text-title--half-first">
              {{ $t('home.blockContentHalf_1.title') }}
            </div>
            <div class="text-content-desc text-content-desc--half-first">
              {{ $t('home.blockContentHalf_1.desc2') }}
            </div>
            <a
              class="btn btn-learn-more"
              href="/product/care">
              {{ $t('common.learnMore') }}
            </a>
          </div>
        </template>
      </block-content>
      <block-content
        class="block-content-home"
        :class="{'block-content-half': !isMobile, 'block-content-full-width': isMobile}">
        <template v-slot:media>
          <img :src="halfSecImgSrc" alt="banner_img">
        </template>
        <template v-slot:text-content>
          <div class="text-content-home text-content-half-sec">
            <div class="text-title text-title--half-sec">
              {{ $t('home.blockContentHalf_2.title') }}
            </div>
            <div class="text-content-desc text-content-desc--half-sec">
              {{ $t('home.blockContentHalf_2.desc') }}
            </div>
            <a
              class="btn btn-learn-more"
              :href="sensorLearnMoreLink"
              target="_self">
              <span v-if="languageCode !== 'zh-Hant'">
                {{ $t('common.learnMore') }}
              </span>
              <span v-else>
                {{ $t('footer.store.main') }}
              </span>
            </a>
          </div>
        </template>
      </block-content>
    </section>
    <div class="divider"></div>
    <section class="section-home">
      <home-rating></home-rating>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import languageList from '../configs/languageList';
import BlockContent from '../components/shared/BlockContent.vue';
import HomeBannerSlider from '../components/sliders/HomeBannerSlider.vue';
import HomeRating from '../components/HomeRating.vue';

export default {
  name: 'Home',
  components: {
    HomeBannerSlider,
    HomeRating,
    BlockContent,
  },
  headMetaInfo() {
    return {
      title: this.$t('headMetaInfo.home.title'),
      titleTemplate: '',
      meta: [
        { name: 'description', content: this.$t('headMetaInfo.home.desc') },
        { property: 'og:title', content: this.$t('headMetaInfo.home.title') },
        { property: 'og:description', content: this.$t('headMetaInfo.home.desc') },
      ],
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      link: (() => {
        // Ugly code, could be better!
        // { rel: 'canonical', href: `${window.location.origin}/` }
        // { rel: 'alternate', hreflang: this.$i18n.locale, href: `${window.location.origin}/` }
        const linkArray = [];
        if (process.env.NODE_ENV === 'prerender') {
          const baseUrl = process.env.BASE_URL.startsWith('http') ? process.env.BASE_URL : 'https://www.lollipop.camera';
          linkArray.push({ rel: 'canonical', href: `${baseUrl}` });
          languageList.forEach((lang) => {
            linkArray.push({ rel: 'alternate', hreflang: lang, href: `${baseUrl}/${lang}/` });
          });
        }
        return linkArray;
      })(),
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
      languageCode: (state) => state.languageCode,
    }),
    secImgSrc() {
      return this.isMobile ? '/media/img/home/block_2_m.jpg'
        : '/media/img/home/block_2.jpg';
    },
    bibImgSrc() {
      return this.isMobile ? '/media/img/home/block_bib_m.jpg'
        : '/media/img/home/block_bib.jpg';
    },
    thirdImgSrc() {
      return this.isMobile ? '/media/img/home/block_3_m.jpg'
        : '/media/img/home/block_3.jpg';
    },
    halfFirstImgSrc() {
      return this.isMobile ? '/media/img/home/m_block_half_breathing.jpg'
        : '/media/img/home/block_half_breathing.jpg';
    },
    halfSecImgSrc() {
      return this.isMobile ? '/media/img/home/block_half_2_m.jpg'
        : '/media/img/home/block_half_2.jpg';
    },
    sensorLearnMoreLink() {
      return this.languageCode !== 'zh-Hant'
        ? 'https://shop.lollipop.camera/products/lollipop-sensor-for-lollipop-baby-monitor-grey?variant=41463576232101'
        : 'https://shopee.tw/Lollipop-Sensor-%E6%A3%92%E6%A3%92%E7%B3%96%E7%9B%A3%E8%A6%96%E5%99%A8%E5%B0%88%E7%94%A8%E6%BA%AB%E6%BF%95%E5%BA%A6%E6%84%9F%E6%B8%AC%E5%99%A8(%E4%B8%8D%E5%8F%AF%E5%96%AE%E7%8D%A8%E4%BD%BF%E7%94%A8)-i.63372023.1097792525?sp_atk=f7ea1380-0b2a-49d2-a2f4-39ca330024dc';
    },
  },
  created() {
    this.scrollToTop();
  },
  beforeMount() {
    window.gtag('event', 'conversion', { send_to: 'AW-851342225/sD5_CIK2rqMBEJHn-ZUD' });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="sass" scoped>
.divider
  width: 100%
  height: 0px
  background-color: $background-primary

.page-home
  .section-home
    --home-text-title: 54px
    --home-text-subtitle: 24px
    --home-btn-text: 16px
    --home-btn-margin-tb: 24px
    --home-sec-color: #729400
    --home-bib-color: #cc9797
    --home-half-width: 50vw
    --home-half-color: #808080
    --home-half-text-title: 48px
    &.section-col-2
      display: flex
    .home-banner-slider-wrapper
      position: relative
      width: 100vw
      height: 80vh
    .block-content-home
      position: relative
      &.block-content-full-width
        width: 100vw
        height: 85vh
      &.block-content-half
        position: relative
        width: var(--home-half-width)
        height: 100vh
        .text-content-home
          text-align: center
      &.block-content-third
        width: 100vw
        height: 85vh
      .text-content-home
        text-align: left
        position: absolute
        &.text-content-sec
          width: 40vw
          top: 50%
          left: 10%
          transform: translate(0%, -50%)
        &.text-content-bib
          width: 40vw
          top: 50%
          left: 50%
          transform: translate(0%, -50%)
        &.text-content-half-first
          width: 80%
          max-width: 640px
          top: 6%
          left: 50%
          transform: translate(-50%, 0%)
        &.text-content-half-sec
          width: 80%
          max-width: 640px
          top: 6%
          left: 50%
          transform: translate(-50%, 0%)
        .text-title
          font-size: var(--home-text-title)
          line-height: 1.25
          margin-bottom: 8px
          &--sec
            color: var(--home-sec-color)
          &--bib
            color: var(--home-bib-color)
          &--half-first, &--half-sec
            font-size: var(--home-half-text-title)
            color: var(--home-half-color)
            margin-bottom: 16px
        .text-content-desc
          &--sec
            color: var(--home-sec-color)
          &--bib
            color: var(--home-bib-color)
          &--half-first, &--half-sec
            color: #808080
        .btn-learn-more
          font-size: var(--home-btn-text)
          font-weight: 700
          margin: var(--home-btn-margin-tb) 0
          &--sec
            color: $main-text-content-color-light
            background-color: var(--home-sec-color)
          &--bib
            color: $main-text-content-color-light
            background-color: var(--home-bib-color)

@media screen and (min-width: 1600px)
  .page-home
    .section-home
      --home-text-title: 72px
      --home-text-subtitle: 32px
      --home-btn-text: 18px
      --home-btn-margin-tb: 32px
      --home-half-text-title: 64px

@media screen and (orientation: portrait)
  .page-home
    .section-home
      --home-half-width: 100vw
      &.section-col-2
        display: flex
        flex-direction: column
      .home-banner-slider-wrapper
        width: 100vw
        height: 90vh
        margin-top: -24px
      .block-content-home
        &.block-content-full-width
          width: 100vw
          height: 100vh
        &.block-content-third
          width: 100vw
          height: 100vh
        .text-content-home
          text-align: center
          position: absolute
          &.text-content-sec
            width: 82%
            top: 6%
            left: 50%
            transform: translate(-50%, 0%)
          &.text-content-bib
            width: 82%
            top: 6%
            left: 50%
            transform: translate(-50%, 0%)
          &.text-content-third
            width: 80%
            top: 6%
            left: 50%
            transform: translate(-50%, 0%)
            .img-amzn-choice
              width: 50vw
          &.text-content-half-first
            width: 85%
            top: 8%
            left: 50%
            transform: translate(-50%, 0%)
          &.text-content-half-sec
            width: 85%
            top: 8%
            left: 50%
            transform: translate(-50%, 0%)

@media screen and (min-width: 960px) and (orientation: portrait)
  .page-home
    .section-home
      --home-text-title: 72px
      --home-text-subtitle: 32px
      --home-btn-text: 28px
      --home-btn-margin-tb: 32px
      --home-half-text-title: 72px

@media screen and (orientation: portrait) and (max-width: 768px) and (min-width: 576px)
  .page-home
    .section-home
      .home-banner-slider-wrapper
        margin-top: -8px

@media screen and (max-width: 768px)
  .page-home
    .section-home
      --home-text-title: 60px
      --home-text-subtitle: 24px
      --home-btn-text: 18px
      --home-btn-margin-tb: 32px
      --home-half-text-title: 60px

@media screen and (max-width: 576px)
  .page-home
    .section-home
      --home-text-title: 36px
      --home-text-subtitle: 20px
      --home-btn-text: 14px
      --home-btn-margin-tb: 20px
      --home-half-text-title: 36px

@media screen and (max-width: 414px)
  .page-home
    .section-home
      --home-text-title: 32px
      --home-text-subtitle: 16px
      --home-btn-text: 14px
      --home-btn-margin-tb: 20px
      --home-half-text-title: 32px
      .block-content-home
        &.block-content-full-width
          height: calc( 100vw * 1.5 )
        &.block-content-third
          height: calc( 100vw * 2 )

@media screen and (max-width: 360px)
  .page-home
    .section-home
      --home-btn-text: 14px

@media screen and (max-width: 320px)
  .page-home
    .section-home
      --home-btn-text: 12px

</style>
